import React from 'react';
import PropTypes from 'prop-types';

import Input from '@style-guide/components/Input';

import {
  reduxInputPropType,
  reduxMetaPropType,
} from '@services/PropTypesFlexi';

import FieldValidationError from '@components/FieldValidationError';

const ReduxFormInputFlexi = ({
  input,
  label = '',
  type = 'text',
  meta: {
    touched,
    error,
  },
  ...restProps
}) => (
  <div>
    <Input
      {...input}
      label={label}
      type={type}
      invalid={!!(touched && error)}
      {...restProps}
    />
    {touched && error && (
      <FieldValidationError>{error}</FieldValidationError>
    )}
  </div>
);

ReduxFormInputFlexi.propTypes = {
  input: reduxInputPropType,
  type: PropTypes.string,
  label: PropTypes.string,
  meta: reduxMetaPropType,
};

ReduxFormInputFlexi.displayName = 'ReduxFormInput';

export default ReduxFormInputFlexi;
